import { useTranslation } from 'react-i18next';
import { useCallback, useEffect } from 'react';
import useWaRegionService from 'src/api/wa/service/WaRegionService';
import { useWaDisasterStore } from 'src/api/wa/store/WaRegionAndDisasterStore';
import LinkButton from 'src/ui/wards/common/button/LinkButton';

type P_SidebarProps = {
  className?: string;
  sitesListSelected: () => void;
  sitesMapSelected: () => void;
  showSummarySelected: () => void;
  logoutSelected: () => void;
};

const P_Sidebar = (props: P_SidebarProps) => {
  const { t } = useTranslation();
  const { getDisasters } = useWaRegionService();
  const { selectedDisaster } = useWaDisasterStore();

  const initialLoader = useCallback(async () => {
    getDisasters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    initialLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="h-max w-60 space-y-1 self-stretch">
      <div className="rounded-md bg-sky-600 py-1 text-center font-bold text-white">
        {t('wards.desktop.menu.title')}
      </div>
      <div className="h-full space-y-4 rounded-md bg-sky-200 p-2">
        <div className="font-bold">{t('wards.desktop.menu.wideAreaDisaster')}</div>
        {selectedDisaster === undefined ? (
          // ローディング中
          <div className="text-sm">{t('wards.desktop.menu.loadingWideAreaDisaster')}</div>
        ) : selectedDisaster && selectedDisaster?.stopDateTime === null ? (
          <div className="flex flex-col space-y-2">
            <div className="flex justify-start ps-2">{`${t('wards.desktop.menu.disasterId')}`}</div>
            <div className="flex justify-start ps-2">{selectedDisaster.id}</div>
            <div>
              <LinkButton
                title={t('wards.desktop.menu.showUnaddressedSitesList')}
                onClick={() => {
                  getDisasters();
                  props.sitesListSelected();
                }}
                className="justify-start ps-2"
              />
            </div>
            <div>
              <LinkButton
                title={t('wards.desktop.menu.showUnaddressedSitesMap')}
                onClick={() => {
                  getDisasters();
                  props.sitesMapSelected();
                }}
                className="justify-start ps-2"
              />
            </div>
            <div>
              <LinkButton
                title={t('wards.desktop.menu.showSummary')}
                onClick={() => {
                  getDisasters();
                  props.showSummarySelected();
                }}
                className="justify-start pb-4 ps-2"
              />
            </div>
          </div>
        ) : (
          <div className="text-sm">{t('wards.desktop.menu.noWideAreaDisaster')}</div>
        )}
        <LinkButton
          title={t('wards.common.logout')}
          onClick={props.logoutSelected}
          className="w-full justify-center"
        />
      </div>
    </div>
  );
};

export default P_Sidebar;
